














import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  props: {
    imageSrc: {
      type: String,
      required: true
    },
    imageClass: {
      type: String,
      required: false,
      default: 'tw-max-h-[80px]'
    }
  },
  setup() {}
})
